/**
 * Функция для глубокого копирования объектов, массивов. Умеет работать с Date, Set, Map
 * @param value Объект
 * @typeParam T Тип объекта
 * @returns Глубокая копия объекта
 * @example
 * ```ts
 * const original = {
 *   name: 'John',
 *   age: 30,
 *   hobbies: ['reading', 'swimming'],
 *   address: {
 *     city: 'Moscow',
 *     street: 'Lenina'
 *   }
 * };
 *
 * const cloned = deepClone(original);
 * console.log(cloned); // Полная копия объекта
 * console.log(cloned === original); // false
 * console.log(cloned.address === original.address); // false
 * ```
 * @example
 * ```ts
 * // Работа с Date, Set, Map
 * const date = new Date('2023-01-01');
 * const set = new Set([1, 2, 3]);
 * const map = new Map([['key', 'value']]);
 *
 * const clonedDate = deepClone(date);
 * const clonedSet = deepClone(set);
 * const clonedMap = deepClone(map);
 *
 * console.log(clonedDate.getTime() === date.getTime()); // true
 * console.log(clonedSet.has(1)); // true
 * console.log(clonedMap.get('key')); // 'value'
 * ```
 */
export function deepClone(value) {
    if (value instanceof Array) {
        const result = new Array(value.length);
        for (let i = 0; i < value.length; i++) {
            result[i] = deepClone(value[i]);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
        return result;
    }
    else if (typeof value === 'object' && value !== null) {
        if (value instanceof Date) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
            return new Date(value.getTime());
        }
        if (value instanceof Map) {
            const map = new Map();
            [...value.entries()].forEach(([itemKey, itemValue]) => {
                map.set(deepClone(itemKey), deepClone(itemValue));
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
            return map;
        }
        if (value instanceof Set) {
            const set = new Set();
            [...value].forEach(item => {
                set.add(deepClone(item));
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
            return set;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- DIRECT-239681
        // @ts-ignore
        const result = value.constructor();
        for (let key in value) {
            result[key] = deepClone(value[key]);
        }
        return result;
    }
    return value;
}
